export default "__VITE_ASSET__KksP2l2___"